export const xovisDataUploadCorrectValues = {
    dataUploadInterval: 'FIFTEEN_MINUTES',
    dataUploadGranularity: 'ONE_MINUTE',
};
